<template>
    <div>
        <div class="table-header row">
            <div>
                状态
            </div>
            <div>
                计算机名/服务器标签
            </div>
            <div>
                IP
            </div>
            <div>操作</div>
        </div>
        <div class="table-body">
            <div class="row" v-for="(item, index) in serverList" :key="index">
                <!-- 状态 -->
                <div>
                    <!-- 远程过的服务器 -->
                    <img
                        src="@/assets/img/icon/recent.png"
                        class="recent"
                        v-show="item.flagIsRemote"
                    />
                    <div v-if="remotingFlagArr.indexOf(item.flag) == -1">
                        <!-- 主服务器在线 -->
                        <img v-show="item.type==1&&item.isOnline==1" class="img"
                        src=@/assets/img/icon/zhu_server_online.png />
                        <!-- 主服务器离线 -->
                        <img v-show="item.type==1&&item.isOnline==0" class="img"
                        src=@/assets/img/icon/zhu_server_offline.png />
                        <!-- 副服务器在线 -->
                        <img v-show="item.type==0&&item.isOnline==1" class="img"
                        src=@/assets/img/icon/fu_server_online.png />
                        <!-- 副服务器离线 -->
                        <img v-show="item.type==0&&item.isOnline==0" class="img"
                        src=@/assets/img/icon/fu_server_offline.png />
                    </div>
                    <div v-if="remotingFlagArr.indexOf(item.flag) > -1">
                        <!-- 远程中服务器 -->
                        <img src=@/assets/img/icon/server_remoting.png
                        class="img" />
                    </div>
                </div>
                <!-- 计算机名/服务器标签 -->
                <div class="computer-name">
                    <div class="one-line">
                        <server-tag-hover-down :tag="item">
                            <div slot="hoverBtn">
                                <div>
                                    <p
                                        v-text="
                                            $PropFn.safeDislayValue(
                                                item.computerName
                                            )
                                        "
                                    ></p>
                                </div>
                            </div>
                        </server-tag-hover-down>
                    </div>
                    <customize-down
                        class="more-btn"
                        :content="
                            item.nickName == '-' || !item.nickName
                                ? '无标签'
                                : item.nickName
                        "
                    >
                        <div slot="down">
                            <div class="setLabel">
                                <ul>
                                    <li
                                        v-for="(it,
                                        ind) in serverLabelList.slice(0, 9)"
                                        :key="ind"
                                        @click="
                                            setLabel(
                                                item.barId,
                                                item.flag,
                                                it.labelId,
                                                item.computerName
                                            )
                                        "
                                    >
                                        <span v-text="it.labelName"></span>
                                    </li>
                                </ul>
                            </div>
                            <i class="line"></i>
                            <div class="drop-row" @click="goServerLabel()">
                                <span>前往服务器标签管理</span>
                            </div>
                        </div>
                    </customize-down>
                </div>
                <!-- IP -->
                <div class="ip-name">
                    <p>
                        <span class="gray-color">(外)</span>
                        <span
                            v-text="$PropFn.safeDislayValue(item.wanIp)"
                        ></span>
                    </p>
                    <p>
                        <span class="gray-color">(内)</span>
                        <span
                            v-text="$PropFn.safeDislayValue(item.localIp)"
                        ></span>
                    </p>
                </div>
                <div class="operate">
                    <a
                        href="#"
                        @click.prevent="
                            $WhdsRemoteProtocal.transferRemote(item, 1, 0, 1)
                        "
                        >极速控制</a
                    >
                    <a href="#" @click.prevent="colorControl(item)">
                        真彩控制<img
                            src="@/assets/img/icon/u44.png"
                            alt=""
                            style="width: 16px;position: relative;top: 5px;left: 1px;"
                        />
                    </a>
                    <a href="#" @click.prevent="viewingMode(item)">
                        观看模式<img
                            style="width: 16px;position: relative;top: 5px;left: 1px;"
                            src="@/assets/img/icon/u43.png"
                            alt=""
                            v-show="
                                $store.state.user.userInfo.judgeVip >= 1 &&
                                    $store.state.user.userInfo.vipStatus > 0
                            "
                        />
                    </a>
                    <a
                        href="#"
                        @click.prevent="
                            $WhdsRemoteProtocal.remoteCmd(
                                {
                                    barId: item.barId,
                                    flag: item.flag,
                                    local: item.localIp,
                                    name: item.barName,
                                    isOnline: item.isOnline
                                },
                                1
                            )
                        "
                        >远程命令</a
                    >
                    <word-down class="more-btn" :content="'更多'">
                        <div slot="down">
                            <!-- <div class=drop-row>
                                <span>使用Radmin连接</span>
                            </div>
                            <div class=drop-row>
                                <span>使用3389连接</span>
                            </div>
                            <i class=line></i> -->
                            <div class="drop-row" @click="restartServe(item)">
                                <span>重启产品服务</span>
                            </div>
                            <i class="line"></i>
                            <div
                                class="drop-row"
                                v-show="
                                    (item.isOnline == 0 && passportType == 0) ||
                                        (passportType == 2 &&
                                            item.isOnline == 0)
                                "
                                @click="delServer(item)"
                            >
                                <span>删除离线服务器</span>
                            </div>
                            <div
                                class="drop-row"
                                @click="sendRemote('关闭', item, 1, 10001)"
                            >
                                <span>关闭服务器</span>
                            </div>
                            <div
                                class="drop-row"
                                @click="sendRemote('重启', item, 1, 10002)"
                            >
                                <span>重启服务器</span>
                            </div>
                            <i class="line"></i>
                            <div
                                class="drop-row"
                                @click="setServerAutoLogin(item)"
                            >
                                <span>设置服务器自动登录</span>
                            </div>
                        </div>
                    </word-down>
                </div>
            </div>
            <no-data
                style="height:auto;padding-top:20px;padding-bottom:20px;"
                :nodata="serverList.length == 0 && !loading"
                :loading="loading"
            ></no-data>
        </div>
    </div>
</template>

<script>
// 插件方法
// 更多悬浮
import WordDown from "_c/dropdown/wordDown";
import ServerTagHoverDown from "_sc/serverTagHoverDown";
import CustomizeDown from "_c/dropdown/customizeDown";
import { sendRemoteCommand } from "@/requests/bar";
import NoData from "_c/noData/noData";
import { mapGetters, mapState } from "vuex";

export default {
    name: "tableData",
    components: {
        WordDown,
        ServerTagHoverDown,
        NoData,
        CustomizeDown
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSelectAll: false,
            serverList: []
        };
    },
    computed: {
        ...mapGetters({
            remotingFlagArr: "plugin/remotingFlagArr"
        }),
        ...mapState({
            passportType: state => state.user.userInfo.passportType,
            serverLabelList: state => state.serverLabel.serverLabelList
        })
    },
    watch: {
        tableList() {
            this.serverList = this.tableList;
        }
    },
    methods: {
        setServerAutoLogin(item) {
            window.$modal.setServerAutoLogin.show(item.barId, item.flag);
        },
        sendRemoteCommand,
        sendRemote(content, item, i, cmdid) {
            if (item.computerName == null) {
                item.computerName = " -- ";
            }
            window.$Message.show({
                title: "是否" + content,
                type: "success",
                msgLeft: "你确认",
                msgCenter: content,
                msg:
                    item.computerName + "(" + item.localIp + ")" + "服务器吗？",
                cancleBtn: true,
                confirmFn: () => {
                    this.sendRemoteCommand(item, i, cmdid);
                    window.$Message.hide();
                }
            });
        },
        restartServe(item) {
            window.$modal.restartServeModal.show(item);
        },
        delServer(item) {
            this.$emit("delOffServer", item);
        },
        setLabel(barId, flag, labelId, computerName) {
            this.$emit("setServerLabel", barId, flag, labelId, computerName);
        },
        goServerLabel() {
            this.$router.push({
                path: this.$PAGE_API.home.children.barManager.children.index
                    .children.serverLabelManage.path
            });
        },
        viewingMode(item) {
            this.$WhdsRemoteProtocal.transferRemote(item, 1, 1, 3);
        },
        colorControl(item) {
            if (
                this.$store.state.user.userInfo.judgeVip == 0 ||
                this.$store.state.user.userInfo.judgeVip == 2 ||
                (this.$store.state.user.userInfo.judgeVip == 1 &&
                    this.$store.state.user.userInfo.vipStatus == 0) ||
                (this.$store.state.user.userInfo.judgeVip == 3 &&
                    this.$store.state.user.userInfo.vipStatus == 0)
            ) {
                this.$router.push({
                    path: this.$PAGE_API.home.children.VIPInfo.path
                });
            } else {
                this.$WhdsRemoteProtocal.transferRemote(item, 1, 0, 2);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
    width: 100%;
    @include clearfix();
    &:after {
        content: "";
        top: 0;
        left: 0;
        display: block;
        font-size: 0;
        height: 0;
        width: 0;
        clear: both;
        visibility: hidden;
    }
    > div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 50px;
        span {
            @include ellipsis();
            display: inline-block;
            max-width: 100%;
        }
        p {
            @include ellipsis();
            max-width: 100%;
            overflow: visible;
        }
        a {
            text-align: left;
            text-indent: 0px;
            margin-right: 8px;
            color: #0066cc;
        }
        input {
            cursor: pointer;
        }
    }
    .more-btn {
        margin-left: 0;
    }
    .severHown {
        line-height: 16px;
        height: 16px;
        font-size: 12px;
    }
    .setLabel {
        padding: 0 8px;
        overflow: hidden;
        ul > li {
            float: left;
            font-size: 12px;
            color: rgb(81, 81, 81);
            background-color: rgb(234, 237, 241);
            height: 25px;
            line-height: 25px;
            padding: 0 8px;
            margin: 0 5px 5px 0;
            cursor: pointer;
            &:hover {
                background-color: #fff;
            }
        }
    }
    > div:nth-child(1) {
        width: 10%;
        text-indent: 10px;
        overflow: hidden;
        .img {
            position: absolute;
            // top: 8px;
            transform: translateY(10px);
        }
    }
    > div:nth-child(2) {
        width: 24%;
    }
    > div:nth-child(3) {
        width: 24%;
    }
    > div:nth-child(4) {
        width: 42%;
    }
}

.table-header {
    > div {
        height: 30px;
        line-height: 30px;
    }
}

.bar-name,
.computer-name,
.ip-name {
    p {
        line-height: normal;
        line-height: 14px;
    }
    p:nth-child(1) {
        padding-top: 10px;
    }
}
.computer-name {
    p:nth-child(1) {
        color: $blue-1;
    }
}

.one-line {
    line-height: 14px;
}
.server {
    .online {
        span {
            color: $green;
        }
    }
    .offline {
        span {
            color: $gray-word;
        }
    }
    img {
        position: relative;
        vertical-align: top;
        top: 18px;
        margin-right: 4px;
    }
}
.gray-color {
    color: $gray-word;
}
.recent {
    position: absolute;
    z-index: 11;
}
</style>
